<template>
  <el-dialog
    :close-on-click-modal="false"
    :v-loading="loading"
    :visible.sync="show"
    @close="onChange"
    bodyHeight="320px"
    class="edit-campaign-rule-modal"
    title
    width="650px"
  >
    <div slot="title">{{ $t('shop-site::campaign_rules::title') }}</div>
    <div class="rule-title">{{ $t('shop-site::campaign_rules::key_title') }}</div>
    <div class="confrim-rule-list">
      <div @click="handleItem($t('shop-site::campaign_rules::staff_button'))" class="confrim-rule-btn">
        {{ $t('shop-site::campaign_rules::staff_button') }}
      </div>
    </div>

    <el-divider></el-divider>
    <div class="rule-title">{{ $t('shop-site::campaign_rules::title') }}  <span class="rule-desc">{{ $t('shop-site::campaign_rules::tip') }}</span></div>
   
    <div class="confrim-rule-box">
      <el-form :model="params" :rules="rules" label-position="top" label-width="140px" ref="form">
        <el-form-item :label="$t('shop-site::campaign_rules::example')" class="input-box" prop="campaignRule">
          <el-input
            :placeholder="$t('shop-site::campaign_rules::placeholder')"
            class="input-item"
            v-model.trim="params.campaignRule"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button :loading="saveLoading" @click="onSave" type="primary">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { accountOptimizingList, saveBindCampaign } from '@/server/marketing.js'
export default {
  name: 'campaign-rule-modal',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible(bool) {
      this.show = bool
      const data = this.drawRow
      if (bool) {
        this.getOptimizingList()
      }
      this.params = {
        id: data.item.id,
        campaignRule: data.item.campaignRule
      }
      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function(data) {},
      deep: true
    }
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      optimList: [],
      rules: {
        campaignRule: [
          { required: true, message: this.$t('shop-site::campaign_rules::placeholder'), trigger: 'change' }
        ]
      },
      show: false,
      params: {}
    }
  },
  mounted() {},
  methods: {
    async getOptimizingList() {
      this.loading = true
      const { data } = await accountOptimizingList({
        pageNum: 1,
        pageSize: 1000,
      })
      if (data.code === this.$code) {
        this.optimList = data.data
      }
      this.loading = false
    },
    handleItem(data) {
      if (this.params.campaignRule) {
        this.params.campaignRule += `_${data.trim()}`
      } else {
        this.params.campaignRule = `_${data.trim()}`
      }
    },
    onChange() {
      this.$emit('change', false)
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.saveLoading = true
          let params = {
            ...this.params
          }
          const { data } = await saveBindCampaign(params)
          if (data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.$emit('save')
            this.$emit('change', false)
          }
          this.saveLoading = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-campaign-rule-modal {
  .confrim-rule-list {
    display: flex;
    flex-wrap: wrap;
    .confrim-rule-btn {
      padding: 7px 15px;
      font-size: 12px;
      margin-bottom: 6px;
      margin-right: 6px;
      border-radius: 3px;
      background: #ffffff;
      border: 1px solid #dcdfe6;
      border-color: #dcdfe6;
      color: #999;
      flex: 0 0 auto;
    }
  }
  .confrim-rule-box {
    border-bottom: 0;
  }
  .rule-title {
    font-size: 14px;
    margin-bottom: 12px;
  }
  .rule-desc {
    color: #999;
    font-size: 12px;
    margin-left: 6px;
  }
  .mini-cell {
    margin-right: 4px;
    margin-left: 0;
    margin-bottom: 4px;
  }
}
</style>
